<template>
    <div>
        <div class="success-panel">
            <div class="icon"><van-icon name="checked" /></div>
            <div class="title">付款成功</div>
            <div class="text">付款金额：{{info.money}}元</div>
            <div class="text">下单时间：{{moment.unix(info.create_time).format('YYYY-MM-DD HH:mm:ss')}}</div>
        </div>
        <div class="ticket_panel" v-if="info.product_class==13">
            <div class="title">购买信息</div>
<!--            <div class="qr"> <img :src="info.e_ticket_qr_file" /> </div>-->
            <div class="content">品名：{{info.product_name}}</div>
            <div class="content">数量：{{info.order_qty}}</div>
            <div class="content">状态：<van-tag :type="ticket_tag_type">{{info.e_ticket_status_name}}</van-tag></div>
            <div class="content" v-if="info.product_memo">备注：{{info.product_memo}}</div>
            <div class="button-box-ticket">
                <van-button class="button" plain type="warning" @click="goMyTicket">查看电子凭证</van-button>
            </div>
        </div>
        <div class="share_panel" v-if="buy_mode==3">
            <div class="title">还差<span>2</span>人拼团成功</div>
            <div class="button-box">
                <van-button class="button" plain type="primary" @click="doShare">{{share_button_text}}</van-button>
            </div>
        </div>
        <div v-if="buy_mode==3">
            <sale-group-list />
        </div>
        <div v-if="buy_mode==1">
            <p><van-button class="button" plain type="default" @click="goBack">返回首页</van-button></p>
            <p><van-button class="button" plain type="primary" @click="goDetail">订单详情</van-button></p>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
    import SaleGroupList from "../../components/SaleGroup/SaleGroupList";
    import {weixin_share} from "../../libs/wxapi";

    export default {
        name: "OrderSuccess",
        components: {SaleGroupList},
        data(){
            return {
                order_id:this.$route.params.order_id,
                product_id:this.$route.params.product_id,
                sales_uid:this.$route.params.sales_uid,
                buy_mode:this.$route.params.buy_mode,
                group_id:this.$route.params.group_id,
                info:{},
                moment:this.$moment,
                ticket_tag_type:'success',
                share_button_text:this.$route.params.buy_mode==3?'邀请朋友一起拼团':'优惠分享给朋友',
                groupInfo:{}    //拼团记录对象
            }
        },
        methods:{
            ...mapActions([
                'GetSaleOrderTicketInfo',
                'GetSaleGroupInfo',
                'WeixinSdkConfig'
            ]),
            loadData(){
                let order_id=this.order_id;
                this.GetSaleOrderTicketInfo({order_id}).then(res=>{
                    this.info = res;
                    this.ticket_tag_type=res.e_ticket_status==5?'success':'warning';
                });

                let group_id=this.group_id;
                this.GetSaleGroupInfo({group_id}).then(res=>{
                    this.groupInfo = res;
                    this.setShareData();
                });
            },
            setShareData(){
                let mode=1,url=encodeURIComponent(window.location.href);
                this.WeixinSdkConfig({mode,url}).then(res=>{
                    if(res.status==0){
                        let data = res.responseObject;
                        data.share_title='梅唐四季◆拼单团购';
                        data.share_desc=this.groupInfo.product_name+'拼团价【'+this.groupInfo.group_price+'】';
                        data.share_link=this.groupInfo.share_base_url+this.product_id+'/'+this.groupInfo.rule_id+'/'+this.group_id;
                        data.share_imgUrl=this.groupInfo.thumb;
                        console.log('传入分享接口的data',data);
                        weixin_share(data);
                    }
                })
            },
            doShare(){
                //调起分享
                this.$toast('请点击右上角按钮进行分享');
            },
            goBack(){
                // let product_id=this.product_id,sales_uid=this.sales_uid;
                // this.$router.push({name:'ProductDetailSale',params:{product_id,sales_uid}});
                this.$router.push({name:'home'});
            },
            goDetail(){
                let order_id=this.order_id;
                this.$router.push({ name: 'OrderDetail',params: {order_id}});
            },
            goMyTicket(){
                this.$router.push({name:'MyTicket',params:{active:'0'}}); //进入待使用的电子票
            }
        },
        mounted() {
            document.body.style.backgroundColor='#F3F4F5';  //设置整页背景色
            this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
    .success-panel{
        background-color: #FFFFFF;
        margin: 14px;
        text-align: center;
        padding-left: 14px;
        border-radius: 10px;
        .icon{
            font-size: 36px;
            color: #07C160;
            padding-top: 4px;
        }
        .title{
            font-size: 20px;
            color: #07C160;
            padding-bottom: 4px;
        }
        .text{
            font-size: 12px;
            color: #666666;
            padding-bottom: 4px;
        }
    }
    .ticket_panel{
        background-color: #FFFFFF;
        margin: 14px;
        padding-left: 14px;
        border-radius: 10px;
        .title{
            font-size: 12px;
            color: #666666;
            font-weight: bold;
            text-align: left;
            padding: 6px;
        }
        .qr{
            text-align: center;
            padding: 10px;
            img{
                height: 200px;
                width: 200px;
            }
        }
        .content{
            text-align: left;
            padding-left: 10px;
            font-size: 12px;
            color: #666666;
            padding-bottom: 4px;
        }
        .button-box-ticket{
            padding-top: 10px;
        }
    }
    .share_panel{
        background-color: #FFFFFF;
        margin: 14px;
        padding-left: 14px;
        border-radius: 10px;
        text-align: center;
        .title{
            font-size: 14px;
            color: #666666;
            padding: 6px;
            span{
                color: #E34928;
            }
        }
        .button-box{
           padding-bottom: 10px;
        }
    }
    .button{
        width: 80%;
        border-radius: 10px;
    }
</style>
